import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

const SidePanel = styled.div`
  border: 1px solid ${color.SILVER};
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.25);
  overflow: hidden;
  width: 100%;
`

export default SidePanel
